// styles
import styled, { css } from 'styled-components';
import { media, gridSizes, weights } from 'utils/style';

const regularCSS = css`
  margin: 0;
  font-weight: ${weights('medium')};
  font-size: 20px;
  margin-bottom: ${gridSizes('M')};
  ${media.lessThan('small')`
    font-size: ${gridSizes('M')};
    `}
`;

export default styled.p`
  ${regularCSS}
`;
